module.exports = "/fonts/NunitoSans-ExtraBold.96b8d9e7bdd3f51969042513baaee8b3.ttf";